import React, { ReactElement, useId, useState } from "react";
import ManualControlBtns from "../../../components/ManualControlBtns";
import { IoIosSettings } from "react-icons/io";
import t from "../../../helpers/i18n";
import CustomModal from "../../../components/CustomModal";

export interface WorkModeInfo {
  key: string;
  label: string;
  onActivate: () => Promise<void>;
  hideManualSwitch: boolean;
  showScheduleSetup: boolean;
}

export default function WorkModeSection({
  modesList,
  currentModeKey,
  manualBtnIsOn,
  switchOnHandler,
  switchOffHandler,
  isScheduletableSetting,
  visSchedule,
}: {
  modesList: WorkModeInfo[];
  currentModeKey?: string;
  manualBtnIsOn: boolean;
  switchOnHandler?: () => Promise<void>;
  switchOffHandler?: () => Promise<void>;
  isScheduletableSetting: boolean;
  visSchedule: ReactElement;
}): ReactElement {
  const [isModalOpened, setOpenedModal] = useState(false);

  let currentMode = modesList.find((mode) => mode.key === currentModeKey);
  if (!currentMode && modesList.length) {
    currentMode = modesList[0];
  }
  const showManualSwitch = !currentMode || !currentMode.hideManualSwitch;
  const showScheduleSetup = currentMode?.showScheduleSetup || false;

  const manualControlBtns = showManualSwitch && switchOnHandler && switchOffHandler && (
    <div style={{ margin: "0 auto" }}>
      <ManualControlBtns
        isOn={manualBtnIsOn}
        switchOnHandler={switchOnHandler}
        switchOffHandler={switchOffHandler}
      />
    </div>
  );

  const scheduleSetupLink = showScheduleSetup && (
    <div>
      <a
        style={{ fontWeight: "bold" }}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          if (!isScheduletableSetting) {
            return;
          }
          setOpenedModal(true);
        }}
      >
        <IoIosSettings style={{ position: "relative", top: "-1px" }} />{" "}
        {t("Schedule setup", "Налаштувати програму")}
      </a>
      <CustomModal
        title={t("Weekly schedule", "Настройка тижневого графіку")}
        isOpen={isModalOpened}
        closeModal={() => setOpenedModal(false)}
        width="900px"
      >
        {visSchedule}
      </CustomModal>
    </div>
  );

  const selectId = useId();
  const workModeSelect = modesList.length > 0 && (
    <div className="text-left" style={{ flexGrow: 1 }}>
      <label htmlFor={selectId} style={{ fontWeight: "bold" }}>
        {t("Work mode:", "Режим роботи:")}
      </label>
      <select
        id={selectId}
        className="form-control"
        value={currentModeKey}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onChange={async (e: React.ChangeEvent<HTMLSelectElement>) => {
          const key = e.target.value;
          const mode = modesList.find((m) => m.key === key);
          if (mode) {
            await mode.onActivate();
          }
        }}
      >
        <option value="" disabled>
          ---
        </option>
        {(modesList || []).map((mode, i) => (
          <option key={i} value={mode.key}>
            {mode.label}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <div style={{ marginBottom: "15px", textAlign: "center" }}>
      <div
        style={{
          display: "flex",
          gap: "15px",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "end",
        }}
      >
        {workModeSelect}
        {manualControlBtns}
      </div>
      {scheduleSetupLink}
    </div>
  );
}
